<template>
  <div>
    <b-modal :id="id" centered size="lg" @show="showModalEdicioEnquesta" @ok="handleSubmitEdicioEnquesta" @hidden="hideModalEdicioEnquesta" :title='$t("admin.enquestes.edicio.titol")'>
      <b-form ref="formEdicioEnquesta" @submit.stop.prevent="handleSubmit">
        <b-form-group
          id="input-group-1"
          :label='$t("admin.enquestes.edicio.descripcio")+":"' label-size="sm"
          label-for="input-1" label-cols="4" label-cols-lg="2"
        >
          <b-form-input
            id="input-1" 
            v-model="formEnquesta.descripcio"
            type="text"
            required size="sm"
            :placeholder='$t("admin.enquestes.edicio.descplaceholder")'
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" :label='$t("admin.enquestes.edicio.questionari")+":"' label-size="sm" label-for="input-2" label-cols="4" label-cols-lg="2">
          <b-form-select required size="sm" id="input-2" v-model="formEnquesta.questionari" :options="questionaris">
            <template v-slot:first>
              <b-form-select-option :value="null">-- {{$t("admin.enquestes.edicio.questionarisel")}} --</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
            
        <b-form-group id="input-group-3" :label='$t("admin.enquestes.edicio.distribucio")+":"' label-size="sm" label-for="input-3"  label-cols="4" label-cols-lg="2">
          <b-form-select required size="sm" id="input-3" v-model="formEnquesta.metodeDistribucio" :options="metodesDistribucio">
            <template v-slot:first>
              <b-form-select-option :value="null">-- {{$t("admin.enquestes.edicio.distribuciosel")}} --</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="input-group-4" :label='$t("admin.enquestes.edicio.agrupacio")+":"' label-size="sm" label-for="input-4"  label-cols="4" label-cols-lg="2">
          <b-form-select required size="sm" id="input-4" v-model="formEnquesta.agrupacio" :options="agrupacions">
            <template v-slot:first>
              <b-form-select-option :value="null">-- {{$t("admin.enquestes.edicio.agrupaciosel")}} --</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>

      </b-form>      
    </b-modal>
  </div>
</template>

<script>
import enquestaService from "../../services/EnquestaService";
import questionariService from "../../services/QuestionariService";
import agrupacioEnquestesService from "@/services/AgrupacioEnquestesService";
export default {
  name: "ModalEdicioEnquesta",
  props: {
    id: {
      type: String,
      required: true
    },
    enquesta:{
      type: Object,
      required: true
    }
  },  
  data() {
    return {
      questionaris:[],
      metodesDistribucio:[],
      agrupacions:[],
      formEnquesta:{}
    };
  },  
  methods: {
    showModalEdicioEnquesta() { 

      this.formEnquesta = this.emptyForm();
      if(this.enquesta.idEnquesta){
            this.formEnquesta.idEnquesta = this.enquesta.idEnquesta;
            this.formEnquesta.descripcio = this.enquesta.descripcio;          
            this.formEnquesta.questionari = this.enquesta.questionari.idQuestionari;
            this.formEnquesta.metodeDistribucio = this.enquesta.metodeDistribucio.codi;
            this.formEnquesta.agrupacio = this.enquesta.idAgrupacio;
      }

    },
    handleSubmitEdicioEnquesta(bvModalEvt) {     
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      
      enquestaService.saveEnquesta(this.formEnquesta).then(response => {        

        this.$emit('enquesta-editada', response.data)
        this.hideModalEdicioEnquesta();

        })
        .catch(e => {
          console.log(e);
      });
     
    },
    emptyForm(){
        return {idEnquesta:null,
        descricpcio:null,
        questionari:null,
        metodeDistribucio:null,
        agrupacio:null}
    },
    hideModalEdicioEnquesta(bvModalEvt) {      
      // Prevent modal from closing
      if(bvModalEvt){bvModalEvt.preventDefault();} 
      
      // Reset our form values
      this.formEnquesta = this.emptyForm();

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide(this.id)
      })       

    },
    checkFormValidity() {
      const valid = this.$refs.formEdicioEnquesta.checkValidity();    
      return valid
    },     
    listQuestionaris() {      
      questionariService.listQuestionaris()
        .then(response => {
          this.questionaris = [];
          var i;
          for (i = 0; i < response.data.length; i++) {
            this.questionaris.push({'value':response.data[i].idQuestionari,'text':response.data[i].titol.text})
          }

        })
        .catch(e => {
          console.log(e);
        });
    },
    listMetodesDistribucio() {
      enquestaService.listMetodesDistribucio()
        .then(response => {
          this.metodesDistribucio = [];
          let i;
          for (i = 0; i < response.data.length; i++) {
            this.metodesDistribucio.push({'value':response.data[i].codi,'text':response.data[i].descripcio})
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    listAgrupacionsBuit(){
      agrupacioEnquestesService.listAgrupacionsBuit(false)
          .then(response => {
            this.agrupacions = [];
            let i;
            for (i = 0; i < response.data.length; i++) {
              this.agrupacions.push({'value':response.data[i].idAgrupacio,'text':response.data[i].nom})
            }
          })
          .catch(e => {
            console.log(e);
          });
    }
    
  },
  mounted() {
      this.listQuestionaris();
      this.listMetodesDistribucio();
      this.listAgrupacionsBuit();
    console.log(this.agrupacions);
  }
};
</script>

<style>
</style>